import React from 'react'

export default function Register() {
  return (
    <div>Register</div>
  )
}
